import React from "react";
import { SpinnerContainer } from "./SpinnerStyled";

export default function SmallSpinner() {
    return (
        <SpinnerContainer>
            <div className="loader">Loading...</div>
        </SpinnerContainer>
    )
}